import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { getCookie, resetCookie, setCookie } from "app/common/utils/cookie.util";
import { environment } from "environments/environment";
import { forkJoin, Observable, of, ReplaySubject, switchMap, tap, throwError } from "rxjs";
import { IUserData } from "../user/user.interface";
import { UserService } from "../user/user.service";
import { MagicWrapperService } from "../wallet/magic/magic-wrapper.service";
import { MagicService } from "../wallet/magic/magic.service";
import { Web3Service } from "../web3/web3.service";
import { ICreateAccount, ICredentials, ISignInResponse } from "./auth.interface";
import { WalletconnectService } from "../wallet/walletconnect/walletconnect.service";
import { WalletconnectWrapperService } from "../wallet/walletconnect/walletconnect-wrapper.service";

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private _authenticated: boolean = false;
    private _loginResponse: ReplaySubject<ISignInResponse> = new ReplaySubject<ISignInResponse>(1);

    constructor(
        private _httpClient: HttpClient,
        private _activatedRoute: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private magicWrapperService: MagicWrapperService,
        private magicService: MagicService,
        private walletconnectWrapperService: WalletconnectWrapperService,
        private walletconnectService: WalletconnectService,
        private web3Service: Web3Service
    ) {
        this.web3Service.accountChanged.pipe().subscribe(_ => { if (_) this.signOut(); })
    }

    signIn(credentials: ICredentials): Observable<ISignInResponse> {
        // Throw error, if the user is already logged in
        if (this._authenticated) {
            return throwError('User is already logged in.');
        }
        return this._httpClient.post<ISignInResponse>(environment.apiBaseUrl + 'playfab/login.php', credentials).pipe(
            //TO get information from playfab api
            // tap((response: ISignInResponse) => {
            //     this.loginPlayFab(response.email, credentials.password).subscribe(r => {
            //         if (r.code == 200) setCookie('playfab-id', r.data.PlayFabId, 30);
            //     })
            // }),
            switchMap((response: ISignInResponse) => {
                if (response.status == "done") {
                    setCookie('playfab-entity-token', response.entityToken, 0.5);
                    setCookie('playfab-session-token', response.sessionTicket, 0.5);
                    setCookie('playfab-entity-id', response.loginResponse.data.EntityToken.Entity.Id, 0.5);
                    setCookie('playfab-id', response.playfabId, 0.5);
                    setCookie('playfab-account-created', response.loginResponse.data.InfoResultPayload.AccountInfo.Created, 0.5);
                    if (!response.walletAddress) this.userService.patchUserInfo({ missingWallet: true });
                    this._loginResponse.next(response);
                }
                return of(response);
            })
        );
    }

    get signinResponse$(): Observable<ISignInResponse> {
        return this._loginResponse.asObservable();
    }

    signUp(post: ICreateAccount, referralCode?: string): Observable<any> {
        return this._httpClient.post<any>(environment.apiBaseUrl + 'playfab/signup-updated.php', post);
    }

    createTalone(wallet: string, referralcode?: string): Observable<any> {
        return this._httpClient.post(environment.apiBaseUrl + 'loyalty/createAccount.php', { walletId: wallet, referralCode: referralcode });
    }

    forgotPassword(email: string) {
        return this._httpClient.post(environment.apiBaseUrl + 'playfab/forgotPassword.php', { email: email });
    }

    //following function will be used only to retrieve playfabID (in dev env php BE doens't exists).
    //TODO try to remove old login.php and use this and other api to retrieve necessary information.
    // loginPlayFab(email: string, password: string): Observable<any> {
    //     return this._httpClient.post(environment.apiPlayfab + 'Client/LoginWithEmailAddress', {
    //         Password: password,
    //         TitleId: environment.apiPlayfab.split('//')[1].split('.')[0],
    //         Email: email
    //     })
    // }

    signOut(): void {
        this._authenticated = false;
        this.userService.isLogged = false;
        resetCookie();
        forkJoin([
            this.magicWrapperService.disconnectProviderMagic(),
            this.walletconnectWrapperService.disconnectProvider()
        ]
        ).subscribe(_ => location.reload());// Reload the app
        // this.magicWrapperService.disconnectProviderMagic().subscribe(result => {
        //     console.log('User logged out', result);
        //     // Reload the app
        //     location.reload();
        // })

        // return of(true);
    }

    check(): Observable<boolean> {
        return this.changePageCheck().pipe(switchMap(
            c => {
                if (c) return of(true);
                else return this.initUserLoggedBefore();
            }
        ))
    }

    changePageCheck(): Observable<boolean> {
        let cookieLogin = getCookie('login');
        let loginEmail = getCookie('loginEmail');
        let playfabID = getCookie('playfab-id');
        let recordedWallet = getCookie('recordedWallet');
        let isWalletMissing = recordedWallet ? false : true;

        if (this.userService.isLogged) {//user already logged, eg. after login, or on refresh page
            this._authenticated = true;
            return of(true);
            // }
            // else if (loginEmail && playfabID && recordedWallet) {
            //     this.userService.initUserInfo({
            //         loginEmail: loginEmail,
            //         playfabID: playfabID,
            //         recordedWallet: recordedWallet
            //     })
            //     if (cookieLogin === 'magic') {
            //         this.magicService.login(loginEmail, isWalletMissing/* , () => console.log('check with Magic') */);
            //         return this.magicService.loggedSuccessfully.pipe(switchMap(
            //             isLogged => of(isLogged)
            //         ))
            //         // let isMagicSetted: boolean = this.magicService.setMagicWeb3();
            //         // if (isMagicSetted) {
            //         //     this.magicService.mountMagic();
            //         //     //TODO linkToPlayFab
            //         //     this.userService.setUserLogged(true);
            //         //     this._authenticated = true;
            //         //     return of(true);
            //         // } else {
            //         //     console.log('Error');
            //         //     return of(false);
            //         // }
            //     } else if ('wallet') {
            //         this.walletconnectService.login(isWalletMissing/* , () => console.log('check with metamask') */)
            //         // return this.walletconnectService.loggedSuccessfully.pipe(switchMap(
            //         //     isLogged => of(isLogged)
            //         // ))
            //     }
            //     else return of(false);//no wallet linked
        } else {
            return of(false);
        }
        //TODO if cookie expired
        // if (!this._authenticated) return of(false);
    }

    initUserLoggedBefore(): Observable<boolean> {
        if (this.isUserLoggedBefore()) {
            let cookieLogin = getCookie('login');
            let loginEmail = getCookie('loginEmail');
            let playfabID = getCookie('playfab-id');
            let recordedWallet = getCookie('recordedWallet');
            let isWalletMissing = recordedWallet ? false : true;
            this.userService.initUserInfo({
                loginEmail: loginEmail,
                playfabID: playfabID,
                recordedWallet: recordedWallet
            })
            if (cookieLogin === 'magic') {
                // this.magicService.login(loginEmail, isWalletMissing);
                // return this.magicService.loggedSuccessfully.pipe(switchMap(
                //     isLogged => of(isLogged)
                // ))
                // let setMagic = this.magicService.setMagicWeb3();
                this.magicService.login(loginEmail, false);
                return this.magicService.loggedSuccessfully.pipe(switchMap(
                    isLogged => {
                        if (isLogged) {
                            this.userService.setUserLogged(true);
                            return of(true);
                        } else {
                            return of(false);
                        }
                    }
                ))
                // if (setMagic) {
                //     // this.magicService.mountMagic();
                //     this.userService.setUserLogged(true);
                //     return of(true);
                // } else return of(false);
            }
            else if (cookieLogin === 'wallet') {
                this.walletconnectService.login(false);
                return this.walletconnectService.loggedSuccessfully.pipe(switchMap(
                    isLogged => {
                        if (isLogged) {
                            this.userService.setUserLogged(true);
                            return of(true);
                        } else {
                            return of(false);
                        }
                    }
                ))
                // return of(true);
            } else {
                return of(false);
            }
        } else return of(false);
    }

    isUserLoggedBefore(): boolean {
        let loginEmail = getCookie('loginEmail');
        let playfabID = getCookie('playfab-id');
        let recordedWallet = getCookie('recordedWallet');
        return loginEmail && playfabID && recordedWallet ? true : false;
    }

    routeAfterSuccessfulLogin(res: ISignInResponse) {
        // if (res.status == "done") {
        let _data: IUserData = {
            playfabID: res.playfabId,
            loginEmail: res.email,
            recordedWallet: res.walletAddress
        }
        this.userService.initUserInfo(_data);
        this.userService.setUserLogged(true);
        const redirectURL = this._activatedRoute.snapshot.queryParamMap.get('redirectURL') || 'signed-in-redirect-user';
        // analyticsTrack('clicked navigation', {
        //     section: 'trainerHub',
        //     value: redirectURL.replace('/', ''),
        // });
        // Navigate to the redirect url


        this.router.navigateByUrl(redirectURL);
        if (!res.walletAddress) this.userService.patchUserInfo({ missingWallet: true });
        // } else {
        //     //ERROR
        //     console.log('errorLogin');
        // }
    }

    //     async getAccounts() {
    //         return await this.contractService.web3.eth.getAccounts().then((accounts) => {
    //             //console.log(accounts)
    //             return accounts;
    //         }).catch((err) => {
    //             return err;
    //             ////console.log(err, 'err!!');
    //         });

    //         /* if (this.accounts.length == 0) {
    //             //this.connection_text = "Grant access";
    //         } else {
    //             //this.connection_text = "Connected";
    //         }

    //         this.accountsObservable.next(this.accounts) */
    //         //this.checkWallet();
    //     }



}



